
import { Stack } from '@fluentui/react';
import { FluentProvider, webLightTheme, SkeletonItem } from '@fluentui/react-components';
import { dashboardTheme, skeleton7, skeleton8, skeletonDataTable8 } from '../../styles/customStyles';

export const SkeletonDataTable = () => {
  return (
    <>
      <FluentProvider style={{ height: '100%' }} theme={dashboardTheme}>
        <Stack style={{ height: '100%' }} tokens={{ childrenGap: 15 }}>
          <SkeletonItem size={24} /*style={skeleton7} */ />
          <SkeletonItem style={skeletonDataTable8} />
        </Stack>
      </FluentProvider>
    </>
  );
};